import { IWebRatingRequestConfig } from './types';

export const FEEDBACK_EMAIL = 'Bt-feedback@neuronation.com';

export const APP_VERSION = 'Web';

export const POSITIVE_FEEDBACK_URLS = {
  de: 'https://bit.ly/testberichte_nn',
  en: 'https://www.trustpilot.com/evaluate/neuronation.com',
  fr: 'https://fr.trustpilot.com/evaluate/neuronation.com',
  ru: 'https://ru.trustpilot.com/evaluate/neuronation.com',
};

// user stat to save the choice
export const FEEDBACK_STAT = '9-14-0';
// configuration on remote config
// feature disabled if firebase not working
export const DEFAULT_WEB_RATING_REQUEST_CONFIG: IWebRatingRequestConfig = {
  enabled: false,
  after_num_workouts: 3,
  on_min_accuracy: 0.9,
  days_after_positive: -1,
  days_after_negative: 365,
  days_after_later: 90,
};
